export default __webpack_public_path__ + "static/media/personImagePlaceholder.20a45d4f.png";